import {combineReducers} from "redux";
import {routerReducer} from "react-router-redux";
import {appReducer} from "modules/App/state/reducer";
import {trackerReducer} from "modules/Tracker/services/reducer";
import {usersReducer} from "modules/Users/services/reducer";
import {rolesReducer} from "modules/Roles/services/reducer";
import {selectEntityByTypeReducer} from "modules/SelectEntityByType/state/reducer";
import {servicesReducer} from "services/reducer";
import {schedulerReducer} from "modules/Scheduler/services/reducer";
import {branchesReducer} from "modules/Branches/services/reducer";
import {brandsReducer} from "modules/Brands/services/reducer";
import {userAgentsReducer} from "modules/UserAgents/services/reducer";
import {objectStructuresReducer} from "modules/ObjectStructures/services/reducer";
import {configManagerReducer} from "modules/ConfigManager/services/reducer";
import {configCIReducer} from "modules/ConfigCI/services/reducer";
import {metricReducer} from "modules/Metric/services/reducer";
import {credentialsManagerReducer} from "modules/CredentialsManager/services/reducer";
import {configManagerLiteReducer} from "modules/ConfigManagerLite/steps/reducer";
import {proxyManagerReducer} from "modules/ProxyManager/services/reducer";
import {quotaManagerReducer} from "modules/QuotaManager/services/reducer";
import {primaryKeyReducer} from "modules/PrimaryKey/services/PrimaryKey/reducer";
import {siteGroupReducer} from "modules/ConfigManager/services/SiteGroup/reducer";
import {brandTrackedDomainReducer} from "modules/Brands/services/BrandTrackedDomains/reducer";
import {queuesReducer} from "modules/Queues/services/reducer";
import {initialScrapeTaskBatchStartsReducer} from "modules/InitialScrapeTaskBatchStarts/services/reducer";

export const rootReducer = combineReducers({
    router: routerReducer,
    app: appReducer,
    services: servicesReducer,
    entityByType: selectEntityByTypeReducer,
    users: usersReducer,
    roles: rolesReducer,
    tracker: trackerReducer,
    scheduler: schedulerReducer,
    branches: branchesReducer,
    brands: brandsReducer,
    userAgents: userAgentsReducer,
    initialScrapeTaskBatchStarts: initialScrapeTaskBatchStartsReducer,
    queues: queuesReducer,
    objectStructures: objectStructuresReducer,
    configManager: configManagerReducer,
    configManagerLite: configManagerLiteReducer,
    configCI: configCIReducer,
    metric: metricReducer,
    credentialsManager: credentialsManagerReducer,
    proxyManager: proxyManagerReducer,
    quotaManager: quotaManagerReducer,
    primaryKey: primaryKeyReducer,
    siteGroup: siteGroupReducer,
    brandTrackedDomain: brandTrackedDomainReducer,
});
